/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CalibrationDataSource = {
    PtwCloud: 'PtwCloud',
    LocalUpload: 'LocalUpload'
} as const;
export type CalibrationDataSource = typeof CalibrationDataSource[keyof typeof CalibrationDataSource];


export function CalibrationDataSourceFromJSON(json: any): CalibrationDataSource {
    return CalibrationDataSourceFromJSONTyped(json, false);
}

export function CalibrationDataSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalibrationDataSource {
    return json as CalibrationDataSource;
}

export function CalibrationDataSourceToJSON(value?: CalibrationDataSource | null): any {
    return value as any;
}

/**
 * Check if a given object implements the CalibrationDataSource interface.
 */
 export function instanceOfCalibrationDataSource(value: any): value is CalibrationDataSource {
    return Object.values(CalibrationDataSource).includes(value)
}

